/* UF4 kit JS — reveal, marquee, tabs, count-up, real-audio engine.
   Re-initialises on shopify:section:load for theme editor.
   v2: per-feature init guards (data-uf4i-*).
   v3: pins support absolute timestamps via data-sec (seconds).
   v4: waveforms auto-fit their container width (were overflowing narrow cards). */
(function(){
  'use strict';
  var PLAY='<svg viewBox="0 0 14 14"><path d="M2 1.5l10 5.5L2 12.5z" fill="currentColor"/></svg>';
  var PAUSE='<svg viewBox="0 0 14 14"><path d="M2.5 1.5h3v11h-3zM8.5 1.5h3v11h-3z" fill="currentColor"/></svg>';
  function fmt(s){s=Math.max(0,Math.floor(s));return Math.floor(s/60)+':'+String(s%60).padStart(2,'0');}

  function initReveal(root){
    var els=root.querySelectorAll('.uf4-rv:not([data-uf4i-rv]),[data-stagger]:not([data-uf4i-rv])');
    if(!els.length)return;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);}});},{threshold:.18});
    els.forEach(function(el){
      el.setAttribute('data-uf4i-rv','1');
      if(el.hasAttribute('data-stagger')){var k=0;Array.prototype.forEach.call(el.children,function(c){c.style.transitionDelay=(k++*70)+'ms';});}
      io.observe(el);
    });
  }
  function initMarquee(root){
    root.querySelectorAll('.uf4-marquee .trk:not([data-uf4i-mq])').forEach(function(t){t.setAttribute('data-uf4i-mq','1');t.innerHTML+=t.innerHTML;});
  }
  function initTabs(root){
    root.querySelectorAll('[data-uf4-tabs]:not([data-uf4i-tb])').forEach(function(tabs){
      tabs.setAttribute('data-uf4i-tb','1');
      var scope=tabs.closest('[data-uf4-scope]')||tabs.parentElement;
      var panes=scope.querySelectorAll('.uf4-pane');
      tabs.querySelectorAll('button').forEach(function(b,i){
        b.addEventListener('click',function(){
          tabs.querySelectorAll('button').forEach(function(x){x.classList.remove('on');});b.classList.add('on');
          panes.forEach(function(p,k){p.classList.toggle('on',k===i);});
        });
      });
    });
  }
  function initCount(root){
    var els=root.querySelectorAll('[data-count]:not([data-uf4i-ct])');
    if(!els.length)return;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(!e.isIntersecting)return;io.unobserve(e.target);
      var el=e.target,raw=String(el.getAttribute('data-count'));
      var m=raw.match(/^\s*([0-9]*\.?[0-9]+)([\s\S]*)$/);
      if(!m)return; /* non-numeric value: leave text as-is */
      var t=parseFloat(m[1]),suf=m[2]||'',pre=el.getAttribute('data-pre')||'',dec=(m[1].split('.')[1]||'').length;
      var t0=performance.now();
      (function f(now){var k=Math.min(1,(now-t0)/1400),v=t*(1-Math.pow(1-k,3));
        el.textContent=pre+v.toFixed(dec)+suf;if(k<1)requestAnimationFrame(f);})(t0);
    });},{threshold:.4});
    els.forEach(function(el){el.setAttribute('data-uf4i-ct','1');io.observe(el);});
  }

  /* ---- audio engine: real <audio>, visuals off real playback ---- */
  var current=null;
  function makeWave(el,n){
    if(el.children.length)return;
    var w=el.clientWidth||(el.parentElement?el.parentElement.clientWidth:0)||600;
    var fit=Math.floor(w/6.5);
    n=Math.max(16,Math.min(n,fit));
    for(var i=0;i<n;i++){var b=document.createElement('i');b.style.setProperty('--h',(18+Math.random()*74).toFixed(0));el.appendChild(b);}
  }
  function karaokePrep(el){
    if(el.getAttribute('data-kprep'))return;el.setAttribute('data-kprep','1');
    var words=el.textContent.trim().split(/\s+/);el.innerHTML='';
    words.forEach(function(w){var s=document.createElement('span');s.textContent=w+' ';el.appendChild(s);});
  }
  function initPlayers(root){
    root.querySelectorAll('[data-uf4-player]:not([data-uf4i-au])').forEach(function(box){
      box.setAttribute('data-uf4i-au','1');
      var audio=box.querySelector('audio');
      var pb=box.querySelector('.uf4-pb');
      var src=audio&&(audio.currentSrc||audio.getAttribute('src')||(audio.querySelector('source')&&audio.querySelector('source').src));
      if(!audio||!src){box.classList.add('uf4-noaudio');return;}
      var wave=box.querySelector('.uf4-wave');if(wave)makeWave(wave,parseInt(wave.getAttribute('data-bars')||'40',10));
      var kt=box.querySelector('.uf4-kt');if(kt)karaokePrep(kt);
      var dur=box.querySelector('.uf4-dur');
      var ring=box.querySelector('[data-ring]');
      var lyr=box.querySelectorAll('[data-phrase]');
      var land=box.querySelector('[data-landrect]');
      var head=box.querySelector('[data-landhead]');
      var pins=box.querySelectorAll('[data-at],[data-sec]');
      var pinSecs=[];pins.forEach(function(pin){var s=pin.getAttribute('data-sec');pinSecs.push(s===null?null:parseFloat(s));});
      audio.addEventListener('loadedmetadata',function(){if(dur)dur.textContent=fmt(audio.duration);});
      if(pb){pb.innerHTML=PLAY;pb.addEventListener('click',function(){
        if(audio.paused){if(current&&current!==audio){current.pause();}current=audio;audio.play();}else audio.pause();
      });}
      audio.addEventListener('play',function(){box.classList.add('playing');if(pb){pb.innerHTML=PAUSE;pb.classList.add('pause');}});
      audio.addEventListener('pause',function(){box.classList.remove('playing');if(pb){pb.innerHTML=PLAY;pb.classList.remove('pause');}});
      audio.addEventListener('ended',function(){audio.currentTime=0;tick();});
      function tick(){
        var d=audio.duration||1,p=audio.currentTime/d,ct=audio.currentTime;
        if(dur)dur.textContent=fmt(d-audio.currentTime);
        if(wave){var bars=wave.children;for(var i=0;i<bars.length;i++){bars[i].classList.toggle('past',i/bars.length<p);}}
        if(kt){var sp=kt.children,idx=Math.floor(p*sp.length);for(var j=0;j<sp.length;j++){sp[j].className=j<idx?'said':(j===idx&&p>0?'now':'');}}
        if(ring){ring.style.strokeDashoffset=100-p*100;ring.style.setProperty('--p',(p*100).toFixed(1));}
        var tile=box.querySelector('[data-ringtile]');if(tile)tile.style.setProperty('--p',(p*100).toFixed(1));
        if(lyr.length){var li=Math.min(lyr.length-1,Math.floor(p*lyr.length));lyr.forEach(function(ph,k){ph.classList.toggle('on',k===li&&p>0);});}
        if(land){land.setAttribute('width',(p*800).toFixed(1));}
        if(head){head.setAttribute('x1',(p*800).toFixed(1));head.setAttribute('x2',(p*800).toFixed(1));}
        if(pins.length){pins.forEach(function(pin,idx){
          var s=pinSecs[idx];
          if(s!==null&&!isNaN(s)){
            var next=null;for(var q=idx+1;q<pinSecs.length;q++){if(pinSecs[q]!==null&&!isNaN(pinSecs[q])){next=pinSecs[q];break;}}
            var end=next!==null?next:s+6;
            pin.classList.toggle('lit',ct>=s&&ct<end&&ct>0);
          }else{
            var at=parseFloat(pin.getAttribute('data-at'));
            pin.classList.toggle('lit',p>=at&&p<at+.22);
          }
        });}
      }
      audio.addEventListener('timeupdate',tick);
    });
  }

  function initAll(root){root=root||document;initReveal(root);initMarquee(root);initTabs(root);initCount(root);initPlayers(root);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initAll(document);});}else{initAll(document);}
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
  window.UF4={init:initAll,fmt:fmt};
})();
